<template>
    <div>
        <!-- Transferir Leito -->
        <div class="modal fade" id="transferirLeitoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Transferir
                            <span class="badge badge-secondary" v-if="edicao">
                                #{{ edicao.id_internacao }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="edicao">
                        <div class="card">
                            <div class="card-body">
                                <celula-dados-paciente :hor="{ 
                                            marcacao: { 
                                                plano: edicao.plano,
                                                paciente: edicao.paciente
                                            }
                                        }" />
                            </div>
                            <div class="card-body" v-if="origem">
                                {{ origem.search }}
                            </div>
                        </div>

                        <az-input 
                            sizing="sm"
                            placeholder="Selecione o leito de destino do paciente..."
                            type="autocomplete" 
                            optionsMode="aql"
                            service="locals.index"
                            optionsName="locals.index.leitos"
                            :optionsSync="false"
                            required 
                            label="Transferir para..."
                            v-model="destino"
                            :validate="validate"
                            :optionsParm="{ 
                                ativos: true,
                                leitos: true, 
                            }"
                            @input312="checar_conflito_local(admissao)" />

                        <div class="alert alert-warning mt-3 mb-0" v-if="info_troca">
                            Paciente no leito destino: {{ troca.paciente.st_nome }}
                        </div>

                        <pre v-if="false">{{ edicao }}</pre>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit @click="atualizar()">
                            {{ info_troca ? 'Trocar' : 'Transferir' }}
                        </az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import CelulaDadosPaciente from '../../shared/table/CelulaDadosPaciente.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzInput from '../../shared/forms/AzInput.vue';

export default {
    data() { 
        return { 
            edicao: null, 
            origem: null, 
            destino: "", 
            validate: false, 
            troca: null, 
        }
    },

    components: { 
        CelulaDadosPaciente, 
        AzInput, 
        AzSubmit
    },

    computed: { 
        info_troca: function () { 
            return this.troca && this.destino && this.troca.id_local == this.destino.id_local;
        }
    },

    methods: { 
        atualizar () { 
            this.$util.atualizar(this, { 
                service: "internados",
                func: "transferir",
                dados: { 
                    id_internacao: this.edicao.id_internacao,
                    id_local: this.destino.id_local, 
                    confirmacao: this.troca ? this.troca.id_internacao : null, 
                },
                callback: res => { 
                    if ( !res ) { 
                        $('.modal').modal('hide');
                        this.$emit('refresh');
                    } else { 
                        this.troca = res;
                    }
                }
            });
        },

        transferir(internacao, leito = null) { 
            this.validate = false; 
            this.destino = "";
            this.troca = null;
            this.edicao = _.cloneDeep(internacao);
            this.origem = _.cloneDeep(leito);
            
            $('#transferirLeitoModal').modal('show');
        }
    }
}
</script>